// extracted by mini-css-extract-plugin
export default {"change-password-modal":"ChangePasswordModal_change-password-modal__PSRfL","current_password":"ChangePasswordModal_current_password__2jycz"};